module.exports = __webpack_public_path__ + "static/homer1015-683c58e351ab5b606c45925688f1ffeb.jpg";